import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { id, riderId } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_RIDER_STATUS, {
      pathParams: {
        riderId: riderId || id,
      },
    })
  },

  method: 'POST',

  format(payload) {
    // POST avec corps vide, l'API bascule automatiquement le statut
    return {}
  },

  parse(raw = {}, payload) {
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Impossible de mettre à jour le statut du livreur',
        data: null,
      }
    }

    const status = raw?.data?.status || 'offline'

    return {
      statusCode: 200,
      message: raw?.message || 'Statut du livreur mis à jour avec succès',
      data: {
        ...raw.data,
        status,
      },
    }
  },
}
